import { SvgIcon, SvgIconProps } from '@mui/material';

// Inline SVG (currentColor) instead of <img src> so the icon stays vector, not rasterized.
export const UsersMenuIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 26 26">
    <path
      d="M17.3334 22.75V20.5833C17.3334 19.4341 16.8769 18.3319 16.0642 17.5192C15.2516 16.7065 14.1494 16.25 13.0001 16.25H6.50008C5.35081 16.25 4.24861 16.7065 3.43595 17.5192C2.62329 18.3319 2.16675 19.4341 2.16675 20.5833V22.75M23.8334 22.75V20.5833C23.8327 19.6232 23.5131 18.6905 22.9249 17.9317C22.3367 17.1728 21.5131 16.6309 20.5834 16.3908M17.3334 3.39083C18.2655 3.62949 19.0917 4.17159 19.6817 4.93167C20.2717 5.69175 20.5919 6.62657 20.5919 7.58875C20.5919 8.55093 20.2717 9.48575 19.6817 10.2458C19.0917 11.0059 18.2655 11.548 17.3334 11.7867M5.41675 7.58333C5.41675 8.7326 5.87329 9.83481 6.68595 10.6475C7.49861 11.4601 8.60081 11.9167 9.75008 11.9167C10.8994 11.9167 12.0016 11.4601 12.8142 10.6475C13.6269 9.83481 14.0834 8.7326 14.0834 7.58333C14.0834 6.43406 13.6269 5.33186 12.8142 4.5192C12.0016 3.70655 10.8994 3.25 9.75008 3.25C8.60081 3.25 7.49861 3.70655 6.68595 4.5192C5.87329 5.33186 5.41675 6.43406 5.41675 7.58333Z"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);

export default UsersMenuIcon;
